// @flow
import CreateAccountContainer from './component'
export default CreateAccountContainer
